import { DEFAULT_ALERT_RANGE } from "assets/constants/defaultAlertRange";
import { Range } from "ts/range";

export const isAlertRangeActive = (alertRange: Range): boolean => {
  return (
    !!alertRange && !Object.keys(alertRange).every((r) => alertRange[r] === DEFAULT_ALERT_RANGE[r])
  );
};
